import Swiper, { Pagination, Autoplay } from 'swiper';

if (document.querySelector('.AsideProductsSlider')) {
    const apSlider = new Swiper('.AsideProductsSlider .swiper', {
        modules: [Pagination, Autoplay],
        loop: true,
        spaceBetween: 16,
        slidesPerView: 1,
        autoplay: {
            delay: 4500,
            pauseOnMouseEnter: true,
        },
        pagination: {
            el: '.AsideProductsSlider__pagination',
        },
    });
}
